<template>
  <div class="skill">
    <div class="skill-icons">
      <i class="fab fa-php" title="PHP"></i> <!-- PHP icon -->
      <i class="fab fa-js" title="JavaScript"></i> <!-- JavaScript icon -->
      <i class="fab fa-laravel" title="Laravel"></i> <!-- Laravel icon -->
      <i class="fab fa-vuejs" title="Vue.js"></i> <!-- Vue.js icon -->
      <i class="fas fa-database" title="SQL"></i> <!-- SQL icon -->
    </div>
  </div>
</template>

<style scoped>
.skill {
  background-color: #007bff; /* Change background to blue */
  color: #fff; /* Set text color to white */
  padding: 20px; /* Increased padding for better spacing */
}

.skill-icons {
  display: flex; /* Use flexbox to align icons horizontally */
  justify-content: center; /* Center icons horizontally */
}

.skill-icons i {
  font-size: 36px; /* Increase icon size */
  margin: 0 15px; /* Add margin between icons */
  transition: transform 0.3s ease; /* Add transition effect */
}

.skill-icons i:hover {
  transform: scale(1.2); /* Enlarge icon on hover */
}
</style>
